module.exports = __webpack_public_path__ + "img/lang-en.b2bf0ff7.jpg";